module.exports = __webpack_public_path__ + "static/img/ethiopia.2e1ecec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/ethiopia.jpg
// module id = Zgym
// module chunks = 1